// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.

/**
 * Dev-bypass auth provider — synthetic admin user, no network, no Firebase.
 *
 * Active when VITE_AUTH_PROVIDER=dev. Use ONLY for offline local development.
 * The synthetic user has isAdmin: true so the existing RequireAdmin guard
 * lets the dashboard through. All credential operations are no-ops.
 *
 * SAFETY: `indexFile` only wires this provider in when PROVIDER === 'dev'
 * AND import.meta.env.DEV is true. A production build with VITE_AUTH_PROVIDER=dev
 * still falls through to the Inferrex provider, so a misconfigured deploy
 * cannot accidentally ship an open admin panel.
 */

import { createContext, useContext, useMemo } from 'react';
import type {
  AuthContextValue, AuthProviderProps, AuthUser, SocialProvider,
} from './types.js';

const DevAuthContext = createContext<AuthContextValue | null>(null);

const DEV_USER: AuthUser = {
  uid: 'dev-bypass-local',
  email: 'dev@local',
  displayName: 'Local Dev',
  roles: ['admin'],
  customerId: 'dev',
};

export function DevBypassAuthProvider({ children }: AuthProviderProps) {
  const value = useMemo<AuthContextValue>(() => ({
    user: DEV_USER,
    loading: false,
    token: 'dev-bypass-token',
    configError: null,
    mfaPending: false,
    isAdmin: true,
    signIn:           async (_e: string, _p: string) => { /* no-op */ },
    signUp:           async (_e: string, _p: string) => { /* no-op */ },
    signInWithSocial: async (_p: SocialProvider)     => { /* no-op */ },
    signOut:          async ()                       => { /* no-op */ },
    resetPassword:    async (_e: string)             => { /* no-op */ },
    getToken:         async ()                       => 'dev-bypass-token',
    verifyMfa:        async (_c: string)             => { /* no-op */ },
  }), []);
  return <DevAuthContext.Provider value={value}>{children}</DevAuthContext.Provider>;
}

export function useDevBypassAuth(): AuthContextValue {
  const ctx = useContext(DevAuthContext);
  if (!ctx) throw new Error('useDevBypassAuth must be used inside DevBypassAuthProvider');
  return ctx;
}
